<ng-container *ngFor="let serviceSchedule of serviceSchedules; let last = last">
  <div
    class="schedule-wrapper {{ !last ? ' bottom-margin' : '' }}"
    [ngClass]="{ 'modal-border': isModal }">
    <div class="row debris-type-row">
      <div class="col">
        {{
          serviceSchedule.debris === 'Unknown'
            ? 'Unspecified Material'
            : serviceSchedule.debris
        }}
      </div>
    </div>

    <div class="row">
      <div class="col equipment-type-text">
        {{ serviceSchedule.accountServiceEquipment }}
      </div>
    </div>
    <div class="row">
      <div
        class="col equipment-type-text"
        *appFeature="'SiteDetailsHaulerName'">
        Hauler Name: {{ serviceSchedule.haulerName }}
      </div>
    </div>

    <div class="row">
      <div
        class="col equipment-type-text"
        *ngIf="serviceSchedule.serviceDetails">
        Service Details: {{ serviceSchedule.serviceDetails }}
      </div>
    </div>

    <div
      class="row equipment-schedule-row"
      *ngIf="serviceSchedule.isRecurringService">
      <div class="col schedule-days">
        <app-service-day-circles
          [serviceDays]="[
            { displayName: 'Sun', onSchedule: serviceSchedule.sunday },
            { displayName: 'Mon', onSchedule: serviceSchedule.monday },
            { displayName: 'Tue', onSchedule: serviceSchedule.tuesday },
            { displayName: 'Wed', onSchedule: serviceSchedule.wednesday },
            { displayName: 'Thu', onSchedule: serviceSchedule.thursday },
            { displayName: 'Fri', onSchedule: serviceSchedule.friday },
            { displayName: 'Sat', onSchedule: serviceSchedule.saturday }
          ]"
          [isRecurringService]="serviceSchedule.isRecurringService"
          [recurringFrequency]="serviceSchedule.recurringFrequency"
          [repeat]="serviceSchedule.repeat"
          [repeatOn]="serviceSchedule.repeatOn"
          [repeatByCode]="serviceSchedule.repeatByCode"
          [everyWeeklySpecfiedDay]="serviceSchedule.everyWeeklySpecfiedDay"
          [everySpecifiedDays]="serviceSchedule.everySpecifiedDays"
          [everySpecifiedMonths]="serviceSchedule.everySpecifiedMonths"
          [dayOfWeek]="serviceSchedule.dayOfWeek"
          [dayOfMonth]="serviceSchedule.dayOfMonth"
          [monthOfYear]="serviceSchedule.monthOfYear"
          [everySpecifiedMonths]="serviceSchedule.everySpecifiedMonths">
        </app-service-day-circles>
      </div>
    </div>
  </div>
</ng-container>
